import { render } from "./CoppyRight.vue?vue&type=template&id=75afa207&scoped=true"
const script = {}

import "./CoppyRight.vue?vue&type=style&index=0&id=75afa207&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75afa207"]])

export default __exports__